export const SETTINGS_SAVED_EVENT_NAME = "settings-saved-event-name";
